import sLang from './spot-history/SpotHistoryPage.lang';
import lang from './map.lang';

export const ORDER_TYPE = {
  0: '-',
  1: 'Market',
  2: 'Limit',
  3: 'Stop',
  4: 'StopLimit',
  5: 'MarketIfTouched',
  6: 'LimitIfTouched',
  7: 'ProtectedMarket',
  8: 'Market',
  9: 'Stop',
  10: 'MarketIfTouched',
  11: 'Bracket',
  12: 'BoTpLimit',
  13: 'BoSlLimit',
  14: 'BoSlMarket',
  '-11': 'Liquidation',
  '-12': 'TrailingStop',
};

export const ITEM_TRADE_TYPE = {
  0: '-',
  1: 'Trade',
  2: 'Liq',
  3: 'ADL',
  4: 'Funding',
  5: 'TakeOver',
  6: 'LiqTrade',
  7: 'AdlTrade',
  8: 'Amend',
  9: 'Cancel',
  10: 'Replace',
  11: 'TransferIn',
  12: 'TransferOut',
  13: 'ExchangeIn',
  14: 'ExchangeOut',
  15: 'PositionSettingChange',
};

export const ORDER_STATUS = {
  1: 'Untriggered',
  2: 'Deactivated',
  3: 'Triggered',
  4: 'Rejected',
  5: 'New',
  6: 'PartiallyFilled',
  7: 'Filled',
  8: 'Canceled',
};

export function WALLET_TYPE(LG) {
  return {
    0: '-',
    1: LG(lang.Deposit),
    2: LG(lang.Withdrawal),
    3: LG(lang.TransferSubAccount),
    4: LG(lang.TransferMainAccount),
    10: LG(lang.Transfer),
    11: LG(lang.Transfer),
    380: LG(lang.Transfer),
    12: LG(lang.Convert),
    13: LG(lang.Convert),
    44: LG(lang.MembershipPurchase),
    50: LG(lang.Commission),
    52: LG(lang.Convert),
    53: LG(lang.Convert),
    58: LG(lang.TransferPhemexTr),
    59: LG(lang.Convert),
    54: LG(lang.TransferToFlexibleSaving),
    55: LG(lang.TransferFormFlexibleSaving),
    56: LG(lang.TransferToFixedSaving),
    60: LG(sLang.PTConvert),
    61: LG(lang.MemeTrade),
    75: LG(lang.LaunchpadCommitment),
    76: LG(lang.LaunchpadDistribution),
    77: LG(lang.LaunchpadSponsor),
    78: LG(lang.LaunchpadSponsorRebate),
    70: LG(lang.LaunchpoolStaking),
    71: LG(lang.LaunchpoolUnstaking),
    72: LG(lang.LaunchpoolRewards),
    73: LG(lang.LaunchpoolSponsor),
    74: LG(lang.LaunchpoolSponsorRebate),
    80: LG(lang.Airdrop),
    81: LG(lang.SpotTradingFeeRebate),
    82: LG(lang.MysteryBox),
    85: LG(lang.c2CAdFreeze), // C2C 创建广告冻结资金
    87: LG(lang.C2cOrderFreeze), // C2C 下单冻结
    89: LG(lang.C2cFundsTransfer), // C2C 放款增加买方资金
    97: LG(lang.ThirdPartyBuy),
    99: LG(lang.CardBuy),
    100: LG(lang.CardSell),
    103: LG(lang.BuyCryptoAirdrop),
    105: LG(lang.AutoDeduction),
    106: LG(lang.AutoFunding),
    110: LG(lang.SpotFeeDeduct), // 现货手续费抵扣券
    111: LG(lang.ContractFeeDeduct), // 合约手续费抵扣券
    112: LG(lang.TransferToFixedActivity),
    115: LG(lang.Swap),
    113: LG(lang.PredictionPlacements),
    114: LG(lang.PredictionRewards),
    120: LG(lang.TransferTradingBots),
    121: LG(lang.TransferTradingBots),
    123: LG(lang.TransferTradingBots),
    124: LG(lang.TransferTradingBots),
    200: LG(lang.Trade),
    211: LG(lang.MarginTradeBorrow),
    212: LG(lang.MarginTradeRepay),
    226: LG(lang.MarginTradeRebate), // MARGIN_FEE_REBATE: margin trade 返佣
    227: LG(lang.MarginTradeDeduct), // MARGIN_FEE_DEDUCT: margin trade 折扣
    228: LG(lang.UnifiedTradeAccountTransfer),
    300: LG(lang.OTCSell),
    301: LG(lang.OTCBuy),
    302: LG(lang.ThirdPartyBuy),
    303: LG(lang.ThirdPartyBuy),
    90: LG(lang.CopyTradeFunds),
    91: LG(lang.CopyTradeFunds),
    92: LG(lang.CopyTradeFunds),
    93: LG(lang.CopyTradeFunds),
    213: LG(lang.MarginTradeTransfer),
    250: LG(lang.XPTConvert),
    251: LG(lang.Web3StakeTradingRewards),
    253: LG(lang.Web3StakeStake),
    254: LG(lang.Web3StakeRedeem),
    255: LG(lang.Web3StakeRewards),
    260: LG(lang.DutchAuction),
    261: LG(lang.DutchAuctionRedeem),
    232: LG(lang.TradingFeeDeduct),
    320: LG(lang.SocialTradingGroupRewards),
    323: LG(lang.SocialGroup),
    324: LG(lang.SocialGroupEntry),
    340: LG(lang.GroupPassMintDeduct),
    341: LG(lang.GroupPassMintIncome),
    342: LG(lang.GroupPassTrade),
    256: LG(lang.Deposit),
    257: LG(lang.Withdrawal),
    325: LG(lang.LendingTransfer),
    362: LG(lang.CreditSettleInterest),
    375: LG(lang.PartnerCashback),
    376: LG(lang.PartnerSplitCommssion),
  };
}

export function SOUL_PASS_WALLET_TYPE(LG) {
  return {
    0: '-',
    50: LG(lang.Commission),
    80: LG(lang.Airdrop),
    105: LG(lang.AutoDeduction),
    106: LG(lang.AutoFunding),
    108: LG(lang.SoulPassXPTPreMining),
    109: LG(lang.Referral),
    116: LG(lang.SoulPassFirstMintedAirdrop),
    250: LG(lang.XPTConvert),
    228: LG(lang.UnifiedTradeAccountTransfer),
  };
}

export function MARGIN_TRADE_TYPE(LG) {
  return {
    0: '-',
    3: LG(lang.TransferSubAccount),
    4: LG(lang.TransferMainAccount),
    105: LG(lang.AutoDeduction),
    106: LG(lang.AutoFunding),
    210: LG(lang.MarginTradeTrading), // MARGIN_TRADING: margin trade 交易
    211: LG(lang.MarginTradeBorrow), // MARGIN_BORROW: margin trade 借款
    212: LG(lang.MarginTradeRepay), // MARGIN_PAYBACK: margin trade 还款
    213: LG(lang.MarginTradeTransfer), // MARGIN_TRANSFER: margin trade 划转
    228: LG(lang.UnifiedTradeAccountTransfer),
    325: LG(lang.LendingTransfer),
  };
}

export function TRADING_ACCOUNT_TYPE(LG) {
  return {
    0: '-',
    1: LG(lang.Deposit),
    3: LG(lang.TransferSubAccount),
    4: LG(lang.TransferMainAccount),
    90: LG(lang.CopyTradeFunds),
    91: LG(lang.CopyTradeFunds),
    92: LG(lang.CopyTradeFunds),
    93: LG(lang.CopyTradeFunds),
    105: LG(lang.AutoDeduction),
    106: LG(lang.AutoFunding),
    120: LG(lang.TransferTradingBots),
    121: LG(lang.TransferTradingBots),
    123: LG(lang.TransferTradingBots),
    124: LG(lang.TransferTradingBots),
    211: LG(lang.MarginTradeBorrow),
    212: LG(lang.MarginTradeRepay),
    227: LG(lang.MarginTradeDeduct),
    228: LG(lang.UnifiedTradeAccountTransfer),
    230: LG(lang.UnifiedSpotTrading),
    231: LG(lang.UnifiedMarginTrading),
    232: LG(lang.TradingFeeDeduct),
    250: LG(lang.XPTConvert),
  };
}

export function FUND_ACCOUNT_TYPE(LG) {
  // on spot: delete 77、78、200、213

  return {
    0: '-',
    1: LG(lang.Deposit),
    2: LG(lang.Withdrawal),
    3: LG(lang.TransferSubAccount),
    4: LG(lang.TransferMainAccount),
    10: LG(lang.Transfer),
    11: LG(lang.Transfer),
    12: LG(lang.Convert),
    13: LG(lang.Convert),
    44: LG(lang.MembershipPurchase),
    50: LG(lang.Commission),
    52: LG(lang.Convert),
    53: LG(lang.Convert),
    58: LG(lang.TransferPhemexTr),
    59: LG(lang.Convert),
    54: LG(lang.TransferToFlexibleSaving),
    55: LG(lang.TransferFormFlexibleSaving),
    56: LG(lang.TransferToFixedSaving),
    75: LG(lang.LaunchpadCommitment),
    76: LG(lang.LaunchpadDistribution),
    70: LG(lang.LaunchpoolStaking),
    71: LG(lang.LaunchpoolUnstaking),
    72: LG(lang.LaunchpoolRewards),
    73: LG(lang.LaunchpoolSponsor),
    74: LG(lang.LaunchpoolSponsorRebate),
    80: LG(lang.Airdrop),
    81: LG(lang.SpotTradingFeeRebate),
    82: LG(lang.MysteryBox),
    85: LG(lang.c2CAdFreeze), // C2C 创建广告冻结资金
    87: LG(lang.C2cOrderFreeze), // C2C 下单冻结
    89: LG(lang.C2cFundsTransfer), // C2C 放款增加买方资金
    97: LG(lang.ThirdPartyBuy),
    99: LG(lang.CardBuy),
    100: LG(lang.CardSell),
    103: LG(lang.BuyCryptoAirdrop),
    105: LG(lang.AutoDeduction),
    106: LG(lang.AutoFunding),
    110: LG(lang.SpotFeeDeduct), // 现货手续费抵扣券
    111: LG(lang.ContractFeeDeduct), // 合约手续费抵扣券
    112: LG(lang.TransferToFixedActivity),
    115: LG(lang.Swap),
    113: LG(lang.PredictionPlacements),
    114: LG(lang.PredictionRewards),
    120: LG(lang.TransferTradingBots),
    121: LG(lang.TransferTradingBots),
    123: LG(lang.TransferTradingBots),
    124: LG(lang.TransferTradingBots),
    226: LG(lang.MarginTradeRebate), // MARGIN_FEE_REBATE: margin trade 返佣
    227: LG(lang.MarginTradeDeduct), // MARGIN_FEE_DEDUCT: margin trade 折扣
    300: LG(lang.OTCSell),
    301: LG(lang.OTCBuy),
    302: LG(lang.ThirdPartyBuy),
    303: LG(lang.ThirdPartyBuy),
    90: LG(lang.CopyTradeFunds),
    91: LG(lang.CopyTradeFunds),
    92: LG(lang.CopyTradeFunds),
    93: LG(lang.CopyTradeFunds),
    228: LG(lang.UnifiedTradeAccountTransfer),
    250: LG(lang.XPTConvert),
    60: LG(sLang.PTConvert),
    251: LG(lang.Web3StakeTradingRewards),
    253: LG(lang.Web3StakeStake),
    254: LG(lang.Web3StakeRedeem),
    255: LG(lang.Web3StakeRewards),
    256: LG(lang.Deposit),
    257: LG(lang.Withdrawal),
    362: LG(lang.CreditSettleInterest),
  };
}

export function INVESTMENT_TYPE(LG) {
  return {
    1001: LG(lang.TransferToFlexibleSaving),
    1005: LG(lang.TransferToFixedSaving),
    1004: LG(lang.TransferFormFlexibleSaving),
    1003: LG(lang.FlexibleSavingIncome),
    1007: LG(lang.FixedSavingIncome),
    1013: LG(lang.TransferInFixedTrialFund),
    1014: LG(lang.FixedTrialFundExpired),
    1015: LG(lang.FixedTrialFundIncome),
    1016: LG(lang.TransferInFlexibleTrialFund),
    1017: LG(lang.FlexibleTrialFundExpired),
    1018: LG(lang.FlexibleTrialFundIncome),
    1019: LG(lang.EarlyRedemptionIncome),
    1020: LG(lang.TransferToFixedActivity),
    1021: LG(lang.FixedActivityIncome),
  };
}

export function LAUNCHPOOL_TYPE(LG) {
  return {
    INVEST: LG(lang.LaunchpoolStaking),
    REDEEM: LG(lang.LaunchpoolUnstaking),
  };
}

export function genWalletType(LG) {
  const options = [
    {value: '1,256', text: LG(lang.Deposit)},
    {value: '2,257', text: LG(lang.Withdrawal)},
    {value: '3', text: LG(lang.TransferSubAccount)},
    {value: '4', text: LG(lang.TransferMainAccount)},
    {value: '10,11,380', text: LG(lang.Transfer)},
    {value: '12,13,52,53,59', text: LG(lang.Convert)},
    {value: '44', text: LG(lang.MembershipPurchase)},
    {value: '50', text: LG(lang.Commission)},
    {value: '54', text: LG(lang.TransferToFlexibleSaving)},
    {value: '55', text: LG(lang.TransferFormFlexibleSaving)},
    {value: '56', text: LG(lang.TransferToFixedSaving)},
    {value: '61', text: LG(lang.MemeTrade)},
    {value: '75', text: LG(lang.LaunchpadCommitment)},
    {value: '76', text: LG(lang.LaunchpadDistribution)},
    {value: '200', text: LG(lang.Trade)},
    {value: '228', text: LG(lang.UnifiedTradeAccountTransfer)},
    {value: '300', text: LG(lang.OTCSell)},
    {value: '301', text: LG(lang.OTCBuy)},
    {value: '99', text: LG(lang.CardBuy)},
    {value: '100', text: LG(lang.CardSell)},
    {value: '58', text: LG(lang.TransferPhemexTr)},
    {value: '70', text: LG(lang.LaunchpoolStaking)},
    {value: '71', text: LG(lang.LaunchpoolUnstaking)},
    {value: '72', text: LG(lang.LaunchpoolRewards)},
    {value: '80', text: LG(lang.Airdrop)},
    {value: '81', text: LG(lang.SpotTradingFeeRebate)},
    {value: '82', text: LG(lang.MysteryBox)},
    {value: '85,87', text: LG(lang.C2cOrderFreeze)}, // C2C 下单冻结 / C2C 创建广告冻结资金
    {value: '89', text: LG(lang.C2cFundsTransfer)}, // C2C 放款增加买方资金
    {value: '97', text: LG(lang.ThirdPartyBuy)},
    {value: '103', text: LG(lang.BuyCryptoAirdrop)},
    {value: '105', text: LG(lang.AutoDeduction)},
    {value: '106', text: LG(lang.AutoFunding)},
    {value: '110', text: LG(lang.SpotFeeDeduct)}, // 现货手续费折扣券
    {value: '111', text: LG(lang.ContractFeeDeduct)}, // 合约手续费折扣券
    {value: '226', text: LG(lang.MarginTradeRebate)}, // MARGIN_FEE_REBATE: margin trade 返佣
    {value: '227', text: LG(lang.MarginTradeDeduct)}, // MARGIN_FEE_DEDUCT: margin trade 折扣
    {value: '112', text: LG(lang.TransferToFixedActivity)},
    {value: '115', text: LG(lang.Swap)},
    {value: '113', text: LG(lang.PredictionPlacements)},
    {value: '114', text: LG(lang.PredictionRewards)},
    {value: '302,303', text: LG(lang.ThirdPartyBuy)},
    {value: '90,91,92,93', text: LG(lang.CopyTradeFunds)},
    {value: '213', text: LG(lang.MarginTradeTransfer)},
    {value: '120,121,123,124', text: LG(lang.TransferTradingBots)},
    {value: '250', text: LG(lang.XPTConvert)},
    {value: '251', text: LG(lang.Web3StakeTradingRewards)},
    {value: '253', text: LG(lang.Web3StakeStake)},
    {value: '254', text: LG(lang.Web3StakeRedeem)},
    {value: '255', text: LG(lang.Web3StakeRewards)},
    {value: '260', text: LG(lang.DutchAuction)},
    {value: '261', text: LG(lang.DutchAuctionRedeem)},
    {value: '232', text: LG(lang.TradingFeeDeduct)},
    {value: '320', text: LG(lang.SocialTradingGroupRewards)},
    {value: '323', text: LG(lang.SocialGroup)},
    {value: '324', text: LG(lang.SocialGroupEntry)},
    {value: '340', text: LG(lang.GroupPassMintDeduct)},
    {value: '341', text: LG(lang.GroupPassMintIncome)},
    {value: '342', text: LG(lang.GroupPassTrade)},
    {value: '325', text: LG(lang.LendingTransfer)},
    {value: '60', text: LG(sLang.PTConvert)},
    {value: '362', text: LG(lang.CreditSettleInterest)},
    {value: '375', text: LG(lang.PartnerCashback)},
    {value: '376', text: LG(lang.PartnerSplitCommssion)},
  ];
  const allIds = options.map(({value}) => value);
  const allIdString = [0, ...allIds].join(',');
  return {
    options: [
      {
        value: allIdString,
        text: LG(lang.All),
      },
      ...options,
    ],
  };
}

export function genTradingAccountType(LG) {
  return {
    options: [
      {value: '', text: LG(lang.All)},
      {value: '1', text: LG(lang.Deposit)},
      {value: '3', text: LG(lang.TransferSubAccount)},
      {value: '4', text: LG(lang.TransferMainAccount)},
      {value: '90,91,92,93', text: LG(lang.CopyTradeFunds)},
      {value: '105', text: LG(lang.AutoDeduction)},
      {value: '106', text: LG(lang.AutoFunding)},
      {value: '211', text: LG(lang.MarginTradeBorrow)},
      {value: '212', text: LG(lang.MarginTradeRepay)},
      {value: '228', text: LG(lang.UnifiedTradeAccountTransfer)},
      {value: '230', text: LG(lang.UnifiedSpotTrading)},
      {value: '231', text: LG(lang.UnifiedMarginTrading)},
      {value: '120,121,123,124', text: LG(lang.TransferTradingBots)},
      {value: '227', text: LG(lang.MarginTradeDeduct)}, // MARGIN_FEE_DEDUCT: margin trade 折扣
      {value: '232', text: LG(lang.TradingFeeDeduct)},
      {value: '250', text: LG(lang.XPTConvert)},
    ],
  };
}

export function genFundAccountType(LG) {
  // on spot: delete 73,74,77,78,200,213
  return {
    options: [
      {
        value:
          '0,1,2,3,4,10,11,12,13,44,50,52,53,54,55,56,58,59,60,70,71,72,75,76,80,81,82,85,87,89,97,99,100,103,105,106,110,111,112,113,114,115,226,227,300,301,302,303,90,91,92,93,120,121,123,124,228,250,251,253,254,255,320,321,322,323,324,256,257,362',
        text: LG(lang.All),
      },
      {value: '1,256', text: LG(lang.Deposit)},
      {value: '2,257', text: LG(lang.Withdrawal)},
      {value: '3', text: LG(lang.TransferSubAccount)},
      {value: '4', text: LG(lang.TransferMainAccount)},
      {value: '10,11', text: LG(lang.Transfer)},
      {value: '12,13,52,53,59', text: LG(lang.Convert)},
      {value: '44', text: LG(lang.MembershipPurchase)},
      {value: '50', text: LG(lang.Commission)},
      {value: '54', text: LG(lang.TransferToFlexibleSaving)},
      {value: '55', text: LG(lang.TransferFormFlexibleSaving)},
      {value: '56', text: LG(lang.TransferToFixedSaving)},
      {value: '75', text: LG(lang.LaunchpadCommitment)},
      {value: '76', text: LG(lang.LaunchpadDistribution)},
      {value: '228', text: LG(lang.UnifiedTradeAccountTransfer)},
      {value: '300', text: LG(lang.OTCSell)},
      {value: '301', text: LG(lang.OTCBuy)},
      {value: '99', text: LG(lang.CardBuy)},
      {value: '100', text: LG(lang.CardSell)},
      {value: '58', text: LG(lang.TransferPhemexTr)},
      {value: '70', text: LG(lang.LaunchpoolStaking)},
      {value: '71', text: LG(lang.LaunchpoolUnstaking)},
      {value: '72', text: LG(lang.LaunchpoolRewards)},
      {value: '80', text: LG(lang.Airdrop)},
      {value: '81', text: LG(lang.SpotTradingFeeRebate)},
      {value: '82', text: LG(lang.MysteryBox)},
      {value: '85,87', text: LG(lang.C2cOrderFreeze)}, // C2C 下单冻结 / C2C 创建广告冻结资金
      {value: '89', text: LG(lang.C2cFundsTransfer)}, // C2C 放款增加买方资金
      {value: '97', text: LG(lang.ThirdPartyBuy)},
      {value: '103', text: LG(lang.BuyCryptoAirdrop)},
      {value: '105', text: LG(lang.AutoDeduction)},
      {value: '106', text: LG(lang.AutoFunding)},
      {value: '110', text: LG(lang.SpotFeeDeduct)}, // 现货手续费折扣券
      {value: '111', text: LG(lang.ContractFeeDeduct)}, // 合约手续费折扣券
      {value: '226', text: LG(lang.MarginTradeRebate)}, // MARGIN_FEE_REBATE: margin trade 返佣
      {value: '227', text: LG(lang.MarginTradeDeduct)}, // MARGIN_FEE_DEDUCT: margin trade 折扣
      {value: '112', text: LG(lang.TransferToFixedActivity)},
      {value: '115', text: LG(lang.Swap)},
      {value: '113', text: LG(lang.PredictionPlacements)},
      {value: '114', text: LG(lang.PredictionRewards)},
      {value: '302,303', text: LG(lang.ThirdPartyBuy)},
      {value: '90,91,92,93', text: LG(lang.CopyTradeFunds)},
      {value: '120,121,123,124', text: LG(lang.TransferTradingBots)},
      {value: '250', text: LG(lang.XPTConvert)},
      {value: '251', text: LG(lang.Web3StakeTradingRewards)},
      {value: '253', text: LG(lang.Web3StakeStake)},
      {value: '254', text: LG(lang.Web3StakeRedeem)},
      {value: '255', text: LG(lang.Web3StakeRewards)},
      {value: '60', text: LG(sLang.PTConvert)},
      {value: '362', text: LG(lang.CreditSettleInterest)},
    ],
  };
}

export function genMarginTradeType(LG) {
  return {
    options: [
      {value: '3,4,105,106,210,211,212,213,228,325', text: LG(lang.All)},
      {value: '3', text: LG(lang.TransferSubAccount)},
      {value: '4', text: LG(lang.TransferMainAccount)},
      {value: '105', text: LG(lang.AutoDeduction)},
      {value: '106', text: LG(lang.AutoFunding)},
      {value: '210', text: LG(lang.MarginTradeTrading)}, // MARGIN_TRADING: margin trade 交易
      {value: '211', text: LG(lang.MarginTradeBorrow)}, // MARGIN_BORROW: margin trade 借款
      {value: '212', text: LG(lang.MarginTradeRepay)}, // MARGIN_PAYBACK: margin trade 还款
      {value: '213', text: LG(lang.MarginTradeTransfer)}, // MARGIN_TRANSFER: margin trade 划转
      {value: '228', text: LG(lang.UnifiedTradeAccountTransfer)},
      {value: '325', text: LG(lang.LendingTransfer)},
    ],
  };
}

export function genInvestmentType(LG) {
  return {
    options: [
      {value: '1001,1003,1004,1005,1007,1013,1014,1015,1016,1017,1018,1019,1020,1021', text: LG(lang.All)},
      {value: '1001', text: LG(lang.TransferToFlexibleSaving)},
      {value: '1005', text: LG(lang.TransferToFixedSaving)},
      {value: '1004', text: LG(lang.TransferFormFlexibleSaving)},
      {value: '1003', text: LG(lang.FlexibleSavingIncome)},
      {value: '1007', text: LG(lang.FixedSavingIncome)},
      {value: '1019', text: LG(lang.EarlyRedemptionIncome)},
      {value: '1013', text: LG(lang.TransferInFixedTrialFund)},
      {value: '1014', text: LG(lang.FixedTrialFundExpired)},
      {value: '1015', text: LG(lang.FixedTrialFundIncome)},
      {value: '1016', text: LG(lang.TransferInFlexibleTrialFund)},
      {value: '1017', text: LG(lang.FlexibleTrialFundExpired)},
      {value: '1018', text: LG(lang.FlexibleTrialFundIncome)},
      {value: '1020', text: LG(lang.TransferToFixedActivity)},
      {value: '1021', text: LG(lang.FixedActivityIncome)},
    ],
  };
}

export function genLaunchPoolType(LG) {
  return {
    options: [
      {value: '', text: LG(lang.All)},
      {value: 'INVEST', text: LG(lang.LaunchpoolStaking)},
      {value: 'REDEEM', text: LG(lang.LaunchpoolUnstaking)},
    ],
  };
}

export function genTradeType(LG) {
  return {
    options: [
      {value: '', text: LG(lang.All)},
      {value: 1, text: LG(lang.DailyRealizedPNL)},
      {value: '2,380', text: LG(lang.Transfer)},
      {value: 3, text: LG(lang.Commission)},
      {value: 4, text: LG(lang.Bonus)},
      {value: 5, text: LG(lang.TransferMainAccount)},
      {value: 6, text: LG(lang.TransferSubAccount)},
      {value: 228, text: LG(lang.UnifiedTradeAccountTransfer)},
      {value: '90,91,92,93', text: LG(lang.CopyTradeFunds)},
      {value: '120,121,123,124', text: LG(lang.TransferTradingBots)},
      {value: '232', text: LG(lang.TradingFeeDeduct)},
      {value: '325', text: LG(lang.LendingTransfer)},
      {value: '371', text: LG(lang.AirdropPosition)},
    ],
  };
}

export function TRADE_TYPE(LG) {
  return {
    1: LG(lang.DailyRealizedPNL),
    2: LG(lang.Transfer),
    380: LG(lang.Transfer),
    3: LG(lang.Commission),
    4: LG(lang.Bonus),
    5: LG(lang.TransferMainAccount),
    6: LG(lang.TransferSubAccount),
    90: LG(lang.CopyTradeFunds),
    91: LG(lang.CopyTradeFunds),
    92: LG(lang.CopyTradeFunds),
    93: LG(lang.CopyTradeFunds),
    120: LG(lang.TransferTradingBots),
    121: LG(lang.TransferTradingBots),
    123: LG(lang.TransferTradingBots),
    124: LG(lang.TransferTradingBots),
    213: LG(lang.MarginTradeTransfer),
    228: LG(lang.UnifiedTradeAccountTransfer),
    232: LG(lang.TradingFeeDeduct),
    325: LG(lang.LendingTransfer),
    371: LG(lang.AirdropPosition),
  };
}

export function PREDICT_RESULT_TYPE(LG) {
  return {
    IN_PREDICTION: LG(lang.InPrediction),
    WIN: LG(lang.Win),
    'WIN&REDEEMED': LG(lang.WinRedeemed),
    LOSE: LG(lang.Lose),
    REFUND: LG(lang.Refund),
  };
}

export function FIAT_ACCOUNT_TYPE(LG) {
  return {
    FIAT_WIRE_DEPOSIT: LG(lang.FiatWireDeposit),
    FIAT_ACH_DEPOSIT: LG(lang.FiatACHDeposit),
    FIAT_WITHDRAWAL: LG(lang.FiatWithdrawal),
    FIAT_WIRE_RETURNED: LG(lang.FiatWireReturned),
    FIAT_WIRE_RESENT: LG(lang.FiatWireReturn),
    USER_PROMOTION: LG(lang.UserPromotion),
    SELL_CRYPTO: LG(lang.SellCrypto),
    BUY_CRYPTO: LG(lang.BuyCrypto),
    AUTO_CONVERSION: LG(lang.AutoConversion),
  };
}

export function genFiatAccountType(LG) {
  return {
    options: [
      {value: '', text: LG(lang.All)},
      {value: 'FIAT_WIRE_DEPOSIT', text: LG(lang.FiatWireDeposit)},
      {value: 'FIAT_ACH_DEPOSIT', text: LG(lang.FiatACHDeposit)},
      {value: 'FIAT_WITHDRAWAL', text: LG(lang.FiatWithdrawal)},
      {value: 'BUY_CRYPTO', text: LG(lang.BuyCrypto)},
      {value: 'SELL_CRYPTO', text: LG(lang.SellCrypto)},
      {value: 'AUTO_CONVERSION', text: LG(lang.AutoConversion)},
      {value: 'FIAT_WIRE_RETURNED', text: LG(lang.FiatWireReturned)},
      {value: 'FIAT_WIRE_RESENT', text: LG(lang.FiatWireReturn)},
      {value: 'USER_PROMOTION', text: LG(lang.UserPromotion)},
    ],
  };
}

const typeIcon = {
  common: 'https://img.phemex.com/v1/b9d3d532-ce9a-4b75-b746-17c4e491f81a/common-funds-icon.png',
  transfer: 'https://img.phemex.com/v1/10e0024e-65b3-442d-9622-f95ea4683585/transfer-funds-icon.png',
  deposit: 'https://img.phemex.com/v1/afe8687f-1a88-471d-8451-cecb18c8091c/deposit-funds-icon.png',
  withdraw: 'https://img.phemex.com/v1/2acc322a-4629-4298-9147-410509f73e31/withdraw-funds-icon.png',
  buySell: 'https://img.phemex.com/v1/5501123a-8788-4bc0-842e-942ac4f695cd/buysell-funds-icon.png',
  convert: 'https://img.phemex.com/v1/fde0de90-378d-4489-9e56-ba40524a2817/convert-funds-icon.png',
};

export const FundsTypeIcon = {
  default: typeIcon.common,
  1: typeIcon.deposit, // Deposit
  2: typeIcon.withdraw, // Withdrawal
  3: typeIcon.transfer, // TransferSubAccount
  4: typeIcon.transfer, // TransferMainAccount
  5: typeIcon.transfer, // TransferMainAccount
  6: typeIcon.transfer, // TransferSubAccount
  10: typeIcon.transfer, // Transfer
  11: typeIcon.transfer, // Transfer
  12: typeIcon.convert, // Convert
  13: typeIcon.convert, // Convert
  52: typeIcon.convert, // Convert
  53: typeIcon.convert, // Convert
  58: typeIcon.transfer, // TransferPhemexTr
  59: typeIcon.convert, // Convert
  54: typeIcon.transfer, // TransferToFlexibleSaving
  55: typeIcon.transfer, // TransferFormFlexibleSaving
  56: typeIcon.transfer, // TransferToFixedSaving
  85: typeIcon.buySell, // c2CAdFreeze // C2C 创建广告冻结资金
  87: typeIcon.buySell, // C2cOrderFreeze // C2C 下单冻结
  89: typeIcon.buySell, // C2cFundsTransfer // C2C 放款增加买方资金
  97: typeIcon.buySell, // ThirdPartyBuy
  99: typeIcon.buySell, // CardBuy
  100: typeIcon.buySell, // CardSell
  112: typeIcon.transfer, // TransferToFixedActivity
  120: typeIcon.transfer, // TransferTradingBots
  121: typeIcon.transfer, // TransferTradingBots
  123: typeIcon.transfer, // TransferTradingBots
  124: typeIcon.transfer, // TransferTradingBots
  300: typeIcon.buySell, // OTCSell
  301: typeIcon.buySell, // OTCBuy
  302: typeIcon.buySell, // ThirdPartyBuy
  303: typeIcon.buySell, // ThirdPartyBuy
  228: typeIcon.transfer, // UnifiedTradeAccountTransfer
  1001: typeIcon.transfer, // TransferToFlexibleSaving
  1005: typeIcon.transfer, // TransferToFixedSaving
  1004: typeIcon.transfer, // TransferFormFlexibleSaving
  1013: typeIcon.transfer, // TransferInFixedTrialFund
  1016: typeIcon.transfer, // TransferInFlexibleTrialFund
  1020: typeIcon.transfer, // TransferToFixedActivity
  213: typeIcon.transfer, // MarginTradeTransfer
  FIAT_WIRE_DEPOSIT: typeIcon.deposit, // FiatWireDeposit
  FIAT_ACH_DEPOSIT: typeIcon.deposit, // FiatACHDeposit
  FIAT_WITHDRAWAL: typeIcon.withdraw, // FiatWithdrawal
  SELL_CRYPTO: typeIcon.buySell, // SellCrypto
  BUY_CRYPTO: typeIcon.buySell, // BuyCrypto
};

export function LENDING_ACCOUNT_FUNDS_TYPE(LG) {
  const lendingMap = {
    325: LG(lang.LendingTransfer),
    326: LG(lang.CollateralDeduction),
    327: LG(lang.LoanBorrow),
    328: LG(lang.CollateralRelease),
    329: LG(lang.LoanPayback),
    350: LG(lang.LendingSupply),
    351: LG(lang.LendingRedeem),
    334: LG(lang.LendingRecvInterest),
  };
  return {
    map: lendingMap,
    options: [
      {value: '', text: LG(lang.All)},
      ...Object.keys(lendingMap).map((key) => ({
        value: key,
        text: lendingMap[key],
      })),
    ],
  };
}
